<template>
  <!-- 行程分享 -->
  <div class="Plan-Share">
    <div class="Plan-Content" v-for="(day,dayIndex) in planData" :key="dayIndex">
      <div class="PC-One">
        <span class="day_icon PCO-Icon">D{{day.planDay}}</span>
        <div class="PCO-City-Date">
          <span>{{ day.planDate | dateFormat }}</span>
          <span>{{day.cityStr}}</span>
        </div>
      </div>
      <div class="PCO-Content" v-for="(budget,budgetIndex) in day.budgetList" :key="budgetIndex">
        <span style="display: flex;padding: 10px;" v-if="budget.state==11">{{ budget.resourceNameCn }}</span>
        <BudgetContent v-else :budget="budget"></BudgetContent>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  import BudgetContent from './children/BudgetContent.vue'
  import { changePlanInfo,citySplicing } from "./model/PlanInfo";
  export default {
    name: 'PlanShare',
    components: {
      BudgetContent
    },
    // 定义属性
    data ()
    {
      return {
        planData: [],
        planId: '',
        budgetMainId: ''
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      init (budgetMainId,planId) {
        this.planId = planId
        this.budgetMainId = budgetMainId
        changePlanInfo({planId: planId,budgetMainId: budgetMainId}).then(pro => {
          this.planData = pro
          console.log("行程天",this.planData)
        })
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created ()
    {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted ()
    {
        //城市新增的监听
        this.$Bus.$on('addCity',data => {
            let find = this.planData.find(x => x.planDay === data.planDay)
            if (find) {
                find.cityList.push(data)
                find.cityStr = citySplicing(find.cityList,"-")
            }
            console.log("城市新增",data,this.planData)
        })
        //删除城市
        this.$Bus.$on('delCity',planCityIdAndPlanDay => {
            //此处最好是重新调用 因为可能涉及到行程天城市下的商品的移除
            this.init(this.budgetMainId,this.planId)
        })
    },
    beforeCreate () { }, // 生命周期 - 创建之前
    beforeMount () { }, // 生命周期 - 挂载之前
    beforeUpdate () { }, // 生命周期 - 更新之前
    updated () { }, // 生命周期 - 更新之后
    beforeDestroy () { }, // 生命周期 - 销毁之前
    destroyed () { }, // 生命周期 - 销毁完成
    activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang="scss" scoped>
  .day_icon{
    width: 0.5rem;
    height: 0.5rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACUklEQVRYR+2Xy2vUUBTGv3NnyhSlUrSVJOMjxZV20UL/gSkW7KRV3Lh2Vt0LdW3Fre6tG3Wj0KXTTkpRO3sf4EaKVDqMTjKtKCoo83ByJKHJvEp7pwSmi7kQuLm533d+OfcmOSF0uVGX4+NAgC/TSqLP4TfK2vYfWdiNa0MDxyvRCRndvgDWjDoHxqLDPH/GLD6QBfhqKCkBeiyj2xegYCgLBLrD4LvxTHFBFqATXRvA1nV9MFoqjbvBhMBNAqUY/MRx8FQWYC/dMaq8P2X++N3q0QRgGdoSwDdkA3U6j8DpKju3zpk7n31tAGAZKgeGjOxuXwdBByMHeIdsa9cREr6YBc7Hl+28e+4BWEl1EYQ5d62JKK2t2O/c8U7WspFsL509reiOQMrdUwCtaBlrtg5gqDsAhol5VDWLH32zb1eG1Kroe8ZEj+IZ67ns7duzisE1ut2qcx/piKB1L7DDI+pqMUfBICOrmfakbJDDzrOS6joIiZrDk2dXi9kAgEEfQJg/rLG0jnGfwGNtANIGIU30X1L1JQD9BHiwwf9lSLF8m6ndjuO+Yir/nMv62vbro7MH0O1N2APoZaCXgV4GupaB78mTJ8oU+9X4jQ75GxDYWTPqBBhvvYEIXdTS1oZXEdmG8oJBV1srojBBmisifCr/jY2NZHMlDyCfPH0hSpHNIGC9JgyPoaEmFEJMKcuFV0FJ5mUhqVyCoCVmjIYXtdmJiC1muqdl7If+laayfCuh98cGKnqt6ihhQ8Si0cJwrT9P5ma50fvAf8OwQVr9ug7wH/8HmjAEHOudAAAAAElFTkSuQmCC) no-repeat;
    background-size: 0.5rem 0.5rem;
    font-weight: bold;
    color: #db4e1a;
    text-align: center;
    line-height: 0.66rem;
    font-size: 0.2rem;
  }
  .Plan-Share {
    padding: 20px;

    .Plan-Content {
      border-left: 2px dashed #db4e1a;
      width: 6rem;
      .PCO-Content{
        box-shadow: 0px 0.01rem 0.1rem 0px #DDDDDD;
        width: 98%;
        margin-left: 15px;
        position: relative;
        border-radius: 0.2rem;
        margin-bottom: 20px;
        margin-top: 10px;
      }

      .PC-One {
        background: white;
        display: flex;
        position: relative;
        left: -0.25rem;
       
        .PCO-Icon {
          transform: scale(0.6);
        }

        .PCO-City-Date {
          display: flex;
          align-items: center;
          >span:nth-child(1) {
            color: #333;
            margin: 0 0.15rem;
            font-size: 0.14rem;
          }
          >span:nth-child(2) {
            color: #333;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>